
import { defineComponent, ref, reactive, computed } from 'vue';
import { useStore } from 'vuex';
import { POST_KEMITRAAN, PUT_KEMITRAAN } from '@/store/kemitraan.module';
import { showError } from '@/utils/swal';

interface KemitraanFormData {
  name?: string;
  picName?: string;
  picPhone?: string;
  description?: string;
  image?: string;
  mou?: string;
}

interface ApiError {
  response?: {
    data?: {
      message?: string;
    };
  };
  message?: string;
}

export default defineComponent({
  props: {
    title: { type: String, required: true },
    id: { type: [String, Number], required: false },
    data: { type: Object, required: false, default: () => ({}) },
  },
  setup(props, { emit }) {
    const store = useStore();
    const modalContent = ref(null);
    const isLoading = ref(false);

    const initialData = props.data as KemitraanFormData;
    const form = reactive({
      name: initialData.name || '',
      picName: initialData.picName || '',
      picPhone: initialData.picPhone || '',
      description: initialData.description || '',
      image: initialData.image || '',
      mou: initialData.mou || '',
    });

    const logoFile = ref<File | null>(null);
    const mouFile = ref<File | null>(null);
    const logoPreviewLocal = ref<string>('');
    const mouName = ref<string>('');

    const logoPreview = computed(() => logoPreviewLocal.value || form.image);

    const onLogoChange = (e: Event) => {
      const input = e.target as HTMLInputElement;
      const file = input.files?.[0] || null;
      logoFile.value = file;
      if (file) {
        const reader = new FileReader();
        reader.onload = () => { logoPreviewLocal.value = (reader.result as string) || ''; };
        reader.readAsDataURL(file);
      }
    };
    const onMouChange = (e: Event) => {
      const input = e.target as HTMLInputElement;
      const file = input.files?.[0] || null;
      mouFile.value = file;
      mouName.value = file?.name || '';
    };

    const closeModal = () => {
      isLoading.value = false;
      emit('close');
    };

    const buildPayload = (): FormData | Record<string, string> => {
      if (logoFile.value || mouFile.value) {
        const fd = new FormData();
        fd.append('name', form.name || '');
        fd.append('picName', form.picName || '');
        fd.append('picPhone', form.picPhone || '');
        fd.append('description', form.description || '');
        if (logoFile.value) fd.append('logo', logoFile.value);
        if (mouFile.value) fd.append('file', mouFile.value);
        return fd;
      }
      return {
        name: form.name,
        picName: form.picName,
        picPhone: form.picPhone,
        description: form.description,
      };
    };

    const handleSubmit = async () => {
      isLoading.value = true;
      try {
        const payload = buildPayload();
        if (props?.id) {
          await store.dispatch(PUT_KEMITRAAN, { id: props.id, data: payload });
        } else {
          await store.dispatch(POST_KEMITRAAN, { data: payload });
        }
        closeModal();
      } catch (error: unknown) {
        const apiError = error as ApiError;
        showError('Gagal', apiError?.response?.data?.message || apiError?.message || 'Gagal menyimpan');
        isLoading.value = false;
      }
    };

    return {
      modalContent,
      form,
      logoPreview,
      mouName,
      isLoading,
      onLogoChange,
      onMouChange,
      closeModal,
      handleSubmit,
    };
  },
});
